import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  AGENT_NAMES,
  ATV_STATUS_LIST,
  BIKE_PRODUCTS,
  GUEST_NAMES,
} from "pages/transaksi/booking/components/Constants";
import { getRandomNum } from "../utils/utils";
import { getRequest, postRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";

// Membuat context untuk loading
const LogReservationContext = createContext();

// Helper function to generate logs with more realistic names
const generateLogReservations = (num) => {
  return Array.from({ length: num }, (_, i) => ({
    id: `KBA ${i + 1090}`,
    name: getRandomNum(GUEST_NAMES),
    guest: 0, // 1 to 5 guests
    bike: 0, // 1 to 3 bikes
    agent: getRandomNum(AGENT_NAMES),
    status: getRandomNum(ATV_STATUS_LIST),
    product: [getRandomNum(BIKE_PRODUCTS)],
    price: getRandomNum(BIKE_PRODUCTS).price,
  }));
};

// Provider untuk context loading
export const LogReservationProvider = ({ children }) => {
  const [logs, setLogReservations] = useState({
    data: [],
    loading: false,
    pagination: null,
    error: null,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
    filters: {
      subject: {
        type: "reservation",
        id: "{{reservation_id}}",
      },
    },
  });

  const buildFilterString = (filters) => {
    const filterEntries = Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `filter[${key}]=${value}`);
    return filterEntries.join("&");
  };

  const updateFilter = (key, value) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [key]: value,
      },
    }));
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      if (e.target.value.trim() === "") {
        setFilterOptions((prevState) => ({
          ...prevState,
          search: "",
        }));
      } else {
        setFilterOptions((prevState) => ({
          ...prevState,
          search: e.target.value,
        }));
      }
    }
  };
  const fetchLogReservations = useCallback(async (reservationId) => {
    setLogReservations((prevState) => ({
      ...prevState,
      loading: true,
    }));
  
    if (!reservationId) {
      console.warn("Reservation ID is missing. Skipping API call.");
      return;
    }
  
    const queryStringWithFilter = buildQueryString({
      limit: 200,
      orderBy: "created_at",
      sort: "desc",
      "filter[subject][type]": "reservation",
      "filter[subject][id]": reservationId, // Gunakan ID dari parameter
    });
  
    try {
      const response = await getRequest(`/log-activity${queryStringWithFilter}`);
  
      if (response.success) {
        setLogReservations({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });
      }
    } catch (error) {
      setLogReservations((prevState) => ({
        ...prevState,
        error: "Failed to fetch log activity",
        loading: false,
      }));
      console.error("Error fetching log activities:", error);
    }
  }, []);
  
  const fetchLogReservationsV1 = useCallback(async () => {
    setLogReservations((prevState) => ({
      ...prevState,
      loading: true,
    }));

    const reservationId = filterOptions.filters.id;

    const queryStringWithFilter = buildQueryString({
      limit: 200,
      orderBy: "created_at",
      sort: "desc",
      "filter[subject][type]": "reservation",
      // "filter[subject][id]": "9e20c7f3-3229-4847-b02a-4fb6b8dc41f3",
      "filter[subject][id]": reservationId,
    });    
  
    try {
      const response = await getRequest(`/log-activity${queryStringWithFilter}`); // Gunakan GET
      if (response.success) {
        setLogReservations({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });
      }
    } catch (error) {
      setLogReservations((prevState) => ({
        ...prevState,
        error: "Failed to fetch log activity",
        loading: false,
      }));
      console.error("Error fetching log activities:", error);
    }
  }, [filterOptions]);

  // useEffect(() => {
  //   fetchLogReservations();
  // }, [filterOptions.filters.reservation_date]);

  // useEffect(() => {
  //   fetchLogReservations();
  // }, [
  //   filterOptions.search,
  //   filterOptions.filters.agent_id,
  //   filterOptions.filters.label_id,
  // ]);

  useEffect(() => {
    if (filterOptions.filters.subject.id) {
      fetchLogReservations(filterOptions.filters.subject.id);
    }
  }, [filterOptions.filters.subject.id]); // Pastikan ID menjadi trigger
  

  const [selectedLogReservation, setSelectedLogReservation] = useState(null);
  const [isOpenCanvas, setIsOpenCanvas] = useState(false);

  return (
    <LogReservationContext.Provider
      value={{
        logs,
        filterOptions,
        fetchLogReservations,
      }}
    >
      {children}
    </LogReservationContext.Provider>
  );
};

// Hook untuk mengakses context loading
export const useLog = () => {
  const context = useContext(LogReservationContext);
  if (!context) {
    throw new Error("useLog must be used within a LogReservationProvider");
  }
  return context;
};
